import { defineQuartzConfig } from 'quartz-core/config';
export default defineQuartzConfig({
  type: 'application',
  loadWhisperCore: true,
  auth: 'app',
  copilotLayoutType: 'panel-with-scroll',
  i18n: {
    includeAllTimezones: true,
    mode: 'very-lazy'
  },
  includeDefaultViewportMetaTag: true,
  logFetchErrors: {
    options: {
      ignoreErrors: [
      // ignore API timeouts, these are not actionable
      /failed with status 0/i,
      // Ignore Chrome extension errors https://github.com/getsentry/sentry/issues/9331
      /_avast_submit/i,
      // Ignore script errors because they aren't actionable
      // TODO: Revisit this after React 17 is rolled out to determine if we
      // should track them in another way.
      'Script error.', "Identifier 'originalPrompt' has already been declared",
      // Grammarly
      // eslint-disable-next-line hubspot-dev/prefer-hubspot-url-utils
      'Blocked a frame with origin "https://app.hubspot.com" from accessing a cross-origin frame.',
      // eslint-disable-next-line hubspot-dev/prefer-hubspot-url-utils
      'Blocked a frame with origin "https://app-eu1.hubspot.com" from accessing a cross-origin frame.',
      //occurs when plugins(or other non react js) add/remove dom nodes, and react loses track during virtual dom reconciliation
      "Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.",
      // Ignore chunk loading errors
      /Loading chunk .* failed./, /Loadable: error loading split chunk/i, /dlb .*bundle.production.js not loaded/i,
      // Error from unknown extension
      "Identifier 'wsWhitelisted' has already been declared"]
    }
  },
  legacy_setupGeneralStore: true,
  mobileManifest: true,
  disableGoogleTranslate: true,
  htmlTitle: 'HubSpot',
  reactStrictMode: true,
  historyBasename: '/contacts/:portalId',
  createRootApi: {
    gate: 'CRM:Records:crm-records-ui:createroot'
  },
  initialPageLoadTracking: true,
  sessionResourceTracking: true,
  sizeLimits: {
    earlyEntry: 1024 * 180 // 180 KiB — current is 170 KiB
  },
  chunkLoadTimeout: 3600000,
  rhumbTrackVisibility: true
});